import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  item: {
    justifyContent: 'center',
    padding: theme.spacings.sm,
    margin: theme.spacings.xs,
    backgroundColor: theme.colors.lightGrey,
    borderRadius: theme.borderRadii.md,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconMargin: {
    marginRight: theme.spacings.xs,
  },
  labelBold: {
    fontSize: theme.fontSizes.xl,
    fontWeight: '600',
  },
  labelNormal: {
    fontSize: theme.fontSizes.xl,
    fontWeight: 'normal',
  },
});
